<iframe allowfullscreen
        data-testid="hubStatistics"
        frameborder="0" sandbox="allow-storage-access-by-user-activation allow-scripts allow-same-origin allow-popups allow-popups-to-escape-sandbox" src="https://lookerstudio.google.com/embed/reporting/910a32cf-26af-42d1-b006-b528779acc4e/page/G4vqE"
        style="border:0; width: 100%;height: 100%"></iframe>
